import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'passwordMask',
  standalone: true
})
export class PasswordMaskPipe implements PipeTransform {
  transform(value: string | null | undefined, maskCharacter: string = '*'): string {
    if (!value) {
      return '';
    }
    return maskCharacter.repeat(value.length);
  }
}
